<template>
  <div>
    <div
      v-if="terms.termsOfService"
      class="content"
      v-html="terms.termsOfService"
    />

    <p
      v-else
      class="message message--danger"
    >
      Oops! Our terms of service failed to load. Please try again later.
    </p>
  </div>
</template>



<script>
  import { mapGetters } from 'vuex';



  export default {
    name: 'TermsAndConditions',

    computed: {
      ...mapGetters('content', ['terms'])
    }
  };
</script>
